import { uiText } from '../i18n/uiText';
import React, { useState } from 'react';
import { authApi, getApiErrorMessage } from '../api';
import { ShieldCheck } from 'lucide-react';
import PageIntro from '../components/ui/PageIntro';
import InterfaceLanguage from '../components/common/InterfaceLanguage';

export default function SecurityPage() {
  const [changeForm, setChangeForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const clearStatus = () => { setMessage(''); setError(''); };

  const submitChange = async (e) => {
    e.preventDefault();
    clearStatus();
    if (changeForm.new_password !== changeForm.confirm_password) {
      setError(uiText("Новый пароль и подтверждение не совпадают."));
      return;
    }
    setLoading(true);
    try {
      await authApi.changePassword({
        current_password: changeForm.current_password,
        new_password: changeForm.new_password,
      });
      setMessage(uiText("Пароль успешно изменён."));
      setChangeForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (e2) {
      setError(getApiErrorMessage(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="workspace-page">
      <PageIntro
        icon={ShieldCheck}
        title={uiText("Пароль и доступ")}
        description={uiText("Измените пароль своей учетной записи. Если войти не получается, отправьте заявку администратору со страницы авторизации.")}
      />

      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <div className="account-security-layout">
        <section className="card account-security-card"><div className="card-header"><div className="card-title">{uiText("Язык приложения")}</div></div><InterfaceLanguage /></section>
        <div className="card account-security-card">
          <div className="card-header"><div className="card-title">{uiText("Сменить пароль")}</div></div>
          <form className="card-body" onSubmit={submitChange} style={{ display: 'grid', gap: 12 }}>
            <div className="form-group">
              <label className="form-label required">{uiText("Текущий пароль")}</label>
              <input className="form-control" type="password" value={changeForm.current_password} onChange={(e) => setChangeForm(prev => ({ ...prev, current_password: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label required">{uiText("Новый пароль")}</label>
              <input className="form-control" type="password" minLength={10} value={changeForm.new_password} onChange={(e) => setChangeForm(prev => ({ ...prev, new_password: e.target.value }))} required />
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{uiText("Не короче 10 символов, минимум 1 буква, 1 цифра и 1 спецсимвол.")}</div>
            </div>
            <div className="form-group">
              <label className="form-label required">{uiText("Подтверждение")}</label>
              <input className="form-control" type="password" minLength={10} value={changeForm.confirm_password} onChange={(e) => setChangeForm(prev => ({ ...prev, confirm_password: e.target.value }))} required />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? uiText("Сохраняю…") : uiText("Изменить пароль")}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
